import PropTypes from "prop-types"
import React, { useContext, useMemo, useRef, useState } from "react"
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material"
import {
  ArrowDropDown as ArrowDropDownIcon,
  ArrowDropUp as ArrowDropUpIcon,
  Check as CheckIcon,
} from "@mui/icons-material"
import { RootDataContext } from "../../../index"
import { predictionModeValues } from "../../../../../manager/data"

const styles = {
  root: {
    backgroundColor: "white",
    border: "1px solid #3c6960",
    height: "30px",
    width: "280px",
    borderRadius: "14px",
    display: "flex",
    flexDirection: "row",
    margin: "auto",
    marginRight: "10px",
  },
  arrowIcon: {
    position: "absolute",
    color: "#3c6960",
    right: "12px",
  },
}

const RootPredictionModeSelectorView = (props) => {
  const [open, setOpen] = useState(false)
  const buttonRef = useRef()
  const keyValues = useMemo(
    () =>
      Object.fromEntries(predictionModeValues.map((e) => [e.value, e.label])),
    []
  )
  const { state, setPredictionMode } = useContext(RootDataContext)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Box sx={{ ...styles.root, ...props.styles }}>
      <Button
        id="selector_prediction_mode"
        sx={{ position: "relative", width: "100%" }}
        ref={buttonRef}
        onClick={handleOpen}
      >
        <Typography color="#3c6960" variant="subtitle2">
          {keyValues[state.predictionMode]
            ? "モデル：" + keyValues[state.predictionMode] + "モデル"
            : "事故予測モデル選択"}
        </Typography>
        {open && <ArrowDropUpIcon fontSize="large" sx={styles.arrowIcon} />}
        {!open && <ArrowDropDownIcon fontSize="large" sx={styles.arrowIcon} />}
      </Button>
      <Menu
        anchorEl={buttonRef.current}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "selector_prediction_mode",
        }}
        PaperProps={{
          style: {
            width: "240px",
          },
        }}
      >
        {predictionModeValues.map((e, i) => {
          return (
            <MenuItem
              key={i}
              onClick={() => {
                setPredictionMode(e.value)
                handleClose()
              }}
            >
              {e.label}モデル
              {state.predictionMode === e.value && (
                <CheckIcon fontSize="small" sx={{ marginLeft: "8px" }} />
              )}
            </MenuItem>
          )
        })}
      </Menu>
    </Box>
  )
}

RootPredictionModeSelectorView.propTypes = {
  styles: PropTypes.object,
}

export default RootPredictionModeSelectorView
